import { pageNameByPartner } from '@/modules/partners/constants';

export function getPartnerActivityTrackingPageName(partner: string) {
  return pageNameByPartner[partner] || `partners-${partner}`;
}
